export const composeReducers = (initialState, action, ...reducers) =>
    reducers.reduce(
        (newState, reducer) => reducer(newState, action),
        initialState
    )
